<script>
// import Layout from '@layouts/member'
import { appMethods } from '@state/helpers'

export default {
  page: {
    title: 'Member Vouchers',
    meta: [{ name: 'description', content: 'Member vouchers' }],
  },

  props: {
    property: { type: Object, required: true },
    vouchers: { type: Array, required: true },
  },

  data: () => ({
    showModal: false,
    item: null,
  }),

  watch: {
    showModal(val) {
      if (!val) this.item = null
    },
  },

  methods: {
    ...appMethods,
    useVoucher(voucher) {
      this.item = voucher
      this.showModal = true
    },
  },
}
</script>

<template>
  <section class="mt-6">
    <div class="container container-page mx-auto px-6">
      <div class="flex flex-wrap -mx-3">
        <template v-if="vouchers.length">
          <div
            v-for="voucher in vouchers"
            :key="voucher.id"
            class="w-full md:w-1/3 mb-6 px-3"
          >
            <div class="border border-gray-500 bg-gray-100 rounded-sm shadow">
              <div class="py-4 px-3 bg-white">
                <h4 class="font-medium">{{ voucher.name }}</h4>
              </div>

              <div class="flex flex-wrap pt-6">
                <div class="w-full px-3">
                  <p class="mb-6 italic">{{ voucher.description }}</p>
                  <div class="flex justify-between items-end mb-6">
                    <span class="text-sm text-gray-500">
                      <strong>Validity:</strong><br />
                      <span class="italic">
                        {{ voucher.validity }}
                      </span>
                    </span>
                    <button class="btn btn-gold" @click="useVoucher(voucher)"
                      >Use</button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div v-else class="w-full mb-6 px-3">
          <p class="font-medium">
            <BaseLink
              class="text-gold-500 underline"
              :to="{ name: 'member-redeem' }"
            >
              Redeem your point
            </BaseLink>
            to variety of attractive vouchers.</p
          >
        </div>
      </div>

      <BaseModal v-model="showModal" title="Use Voucher">
        <template v-if="showModal">
          <p class="mb-3">
            Please show this QR code to reception upon check-in to use your
            voucher.
          </p>
          <div class="flex flex-col items-center">
            <qriously :value="item.redeemUrl" :size="200" />
            <span>Voucher ID: {{ item.id }}</span>
          </div>
        </template>
      </BaseModal>
    </div>
  </section>
</template>
